import { StyleSheet } from "react-native";

export const commonStyles = StyleSheet.create({
  container: {
    paddingHorizontal: 8,
  },
});
